// extracted by mini-css-extract-plugin
export default {"content":"FinishPetition_content__UlSzg","title":"FinishPetition_title__8nj7Y","btns":"FinishPetition_btns__P-pAZ"};